import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { InpostCategory, InpostCategoryService } from '../inpost-category.service';

interface CategoryFlatNode {
  id: string;
  name: string;
  leaf: boolean;
  level: number;
  expandable: boolean;
}

@Component({
  selector: 'app-inpost-category-dialog',
  templateUrl: './inpost-category-dialog.component.html',
  styles: [`
    .category-tree { max-height: 500px; overflow-y: auto; }
    .selected { background-color: rgba(63, 81, 181, 0.12); }
    .node-name { cursor: pointer; padding: 4px 8px; border-radius: 4px; }
    .node-name:hover { background-color: rgba(0, 0, 0, 0.04); }
    .leaf-icon { color: #4caf50; font-size: 18px; margin-right: 4px; }
  `],
})
export class InpostCategoryDialogComponent implements OnInit {
  selectedCategory: InpostCategory | null = null;
  loading = true;

  private transformer = (node: InpostCategory, level: number): CategoryFlatNode => ({
    id: node.id,
    name: node.name,
    leaf: node.leaf,
    level,
    expandable: !node.leaf && !!node.children && node.children.length > 0,
  });

  treeControl = new FlatTreeControl<CategoryFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  private treeFlattener = new MatTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(
    private readonly dialogRef: MatDialogRef<InpostCategoryDialogComponent>,
    private readonly categoryService: InpostCategoryService,
  ) {}

  ngOnInit(): void {
    this.categoryService.getCategories(undefined, 4).subscribe(categories => {
      this.dataSource.data = categories;
      this.loading = false;
    });
  }

  hasChild = (_: number, node: CategoryFlatNode) => node.expandable;

  isSelected(node: CategoryFlatNode): boolean {
    return this.selectedCategory?.id === node.id;
  }

  selectNode(node: CategoryFlatNode): void {
    this.selectedCategory = { id: node.id, name: node.name, leaf: node.leaf };
  }

  confirm(): void {
    this.dialogRef.close(this.selectedCategory);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
